import { WindowState } from '../state';
import { GlazingTier } from '../types';

const GLAZING_OPTIONS: { value: GlazingTier; label: string }[] = [
  { value: GlazingTier.HR, label: 'HR (Double)' },
  { value: GlazingTier.HR_PLUS, label: 'HR+ (Double)' },
  { value: GlazingTier.HR_PLUS_PLUS, label: 'HR++ (Double)' },
  { value: GlazingTier.HR_TRIPLE, label: 'HR+++ (Triple)' },
  { value: GlazingTier.VACUUM, label: 'Vacuum' },
];

export function createGlazingSelector(state: WindowState): HTMLElement {
  const container = document.createElement('div');

  const row = document.createElement('div');
  row.className = 'opt-row';

  const label = document.createElement('span');
  label.className = 'opt-label';
  label.textContent = 'Tier';

  const select = document.createElement('select');
  select.className = 'opt-select';

  for (const opt of GLAZING_OPTIONS) {
    const option = document.createElement('option');
    option.value = opt.value;
    option.textContent = opt.label;
    if (state.config.glazingTier === opt.value) option.selected = true;
    select.appendChild(option);
  }

  select.addEventListener('change', () => {
    state.setGlazingTier(select.value as GlazingTier);
  });

  row.appendChild(label);
  row.appendChild(select);
  container.appendChild(row);

  return container;
}
